import Vue from 'vue'
import { omit } from 'lodash'
import inform from '@/services/inform'

// State
const state = {
  isLoading: false,
  isSaving: false,
  data: null,
  selectedUser: null
}

// Mutations
const fetchUsersRequest = 'fetchUsersRequest'
const fetchUsersResponse = 'fetchUsersResponse'
const saveUserRequest = 'saveUserRequest'
const saveUserResponse = 'saveUserResponse'
export const selectUser = 'selectUser'
export const unselectUser = 'unselectUser'
const deleteUserRequest = 'deleteUserRequest'
const deleteUserResponse = 'deleteUserResponse'

const mutations = {
  [fetchUsersRequest] (state) {
    state.isLoading = true
  },
  [fetchUsersResponse] (state, users) {
    state.isLoading = false
    state.data = users
  },
  [saveUserRequest] (state) {
    state.isSaving = true
  },
  [saveUserResponse] (state, user) {
    state.isSaving = false
    if (!user) {
      return
    }
    const index = state.data.findIndex(({ id }) => id === user.id)
    if (index > -1) {
      state.data = [
        ...state.data.slice(0, index),
        { ...state.data[index], ...user },
        ...state.data.slice(index + 1)
      ]
    } else {
      state.data = [...state.data, user]
    }
  },
  [selectUser] (state, user) {
    state.selectedUser = user
  },
  [unselectUser] (state) {
    state.selectedUser = null
  },
  [deleteUserRequest] (state, user) {
    state.isSaving = true
  },
  [deleteUserResponse] (state, user) {
    state.isSaving = false
    if (user) {
      state.data = state.data.filter(({ id }) => id !== user.id)
    }
  }
}

// Actions
export const fetchUsers = 'fetchUsers'
export const saveUser = 'saveUser'
export const deleteUser = 'deleteUser'

const actions = {
  [fetchUsers]: ({ commit, dispatch }) => {
    commit(fetchUsersRequest)
    return Vue.http.get(`${SERVER_URL}/users`).then(({ data: users }) => {
      commit(fetchUsersResponse, users)
    })
  },
  [saveUser]: ({ commit }, user) => {
    commit(saveUserRequest)

    let request
    // UPDATE
    if (user.id) {
      request = Vue.http.put(
        `${SERVER_URL}/users/${user.id}`,
        omit(user, ['id'])
      )
    } else {
      // CREATE
      request = Vue.http.post(`${SERVER_URL}/users`, user)
    }

    return request
      .then(({ data: user }) => {
        commit(saveUserResponse, user)
        return user
      })
      .catch(() => {
        commit(saveUserResponse, null)
        return null
      })
  },
  [deleteUser] ({ commit }, user) {
    commit(deleteUserRequest, user)
    return Vue.http
      .delete(`${SERVER_URL}/users/${user.id}`)
      .then(() => {
        inform(
          `Benutzer "${user.firstName} ${user.lastName}" erfolgreich gelöscht`
        )
        commit(deleteUserResponse, user)
      })
      .catch(() => {
        commit(deleteUserResponse, null)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js